export const createOptions = (options = null, page = "") => {
    let source = "?";

    if (options) {
        options = Object.keys(options).map(
            (key) => (source = source + key + "=" + options[key] + "&")
        );
    }

    if (page) source = source + "page=" + page;
    else source = source.substr(0, source.length - 1);

    return source;
};

export function _buildFormData(formData, data, parentKey) {
    if (
        data &&
        typeof data === "object" &&
        !(data instanceof Date) &&
        !(data instanceof File)
    ) {
        Object.keys(data).forEach((key) => {
            this._buildFormData(
                formData,
                data[key],
                parentKey ? `${parentKey}[${key}]` : key
            );
        });
    } else {
        const value = data == null ? "" : data;

        formData.append(parentKey, value);
    }
}

export function getImageUrl(url, width = null, height = null) {
    let imageOptions = "";

    if (width && !height) {
        imageOptions =
            "?w=" + Math.round(width * window.devicePixelRatio * 1.2);
    } else if (!width && height) {
        imageOptions =
            "?h=" + Math.round(height * window.devicePixelRatio * 1.2);
    } else if (width && height) {
        imageOptions =
            "?w=" +
            Math.round(width * window.devicePixelRatio * 1.2) +
            "&h=" +
            Math.round(height * window.devicePixelRatio * 1.2);
    }

    return url + imageOptions;
}

export function getUrl(route = "") {
    let locale = window.location.pathname.split("/")[1];

    let url = route;
    if (url.charAt(0) === "/") {
        url = url.slice(1);
    }

    return "/" + locale + "/" + url;
}

export function isTouch() {
    return (
        !!("ontouchstart" in window) || window.navigator.msMaxTouchPoints > 0
    );
}

export function isFileValid(event) {
    return new Promise((resolve, reject) => {
        const maxFileSize = 5000000;

        let response = {
            size: true,
        };

        if (event.size > maxFileSize) {
            response.size = false;
        }

        resolve(response);
    });
}

export function isImageValid(event) {
    return new Promise((resolve, reject) => {
        const maxFileSize = 5000000;

        let response = {
            size: true,
            resolution: true,
        };

        if (event.size > maxFileSize) {
            response.size = false;
        }

        let img = new Image();
        img.src = URL.createObjectURL(event);
        img.onload = function () {
            if (this.height > 2500 || this.width > 2500) {
                response.resolution = false;
            }

            resolve(response);
        };
        img.onerror = reject;
    });
}

export function isBrightColor(color) {
    // Variables for red, green, blue values
    var r, g, b, hsp;

    // Check the format of the color, HEX or RGB?
    if (color.match(/^rgb/)) {
        // If HEX --> store the red, green, blue values in separate variables
        color = color.match(
            /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/
        );

        r = color[1];
        g = color[2];
        b = color[3];
    } else {
        // If RGB --> Convert it to HEX: http://gist.github.com/983661
        color = +(
            "0x" + color.slice(1).replace(color.length < 5 && /./g, "$&$&")
        );

        r = color >> 16;
        g = (color >> 8) & 255;
        b = color & 255;
    }

    // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
    hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));

    // Using the HSP value, determine whether the color is light or dark

    if (hsp > 160) {
        return true;
    } else {
        return false;
    }
}

export function fixExternalLinks(string) {
    var temp = document.createElement("div");
    temp.innerHTML = string;

    var links = temp.getElementsByTagName("a");
    if (links) {
        for (var i = 0, max = links.length; i < max; i++) {
            if (links[i].host !== location.host) {
                links[i].target = "_blank";
            }
        }
    }

    return temp.innerHTML;
}
